module.exports = __webpack_public_path__ + "static/media/problem-solving.5309986f.svg";